module.exports = __webpack_public_path__ + "static/media/ultthurs.5e28cc3a.jpg";